import { c as _c } from "react/compiler-runtime";
import { envConfigs } from '@/config';
import { Button } from '@/shared/components/ui/button';
export function BuiltWith() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button variant="outline" size="sm" className="hover:bg-primary/10 cursor-default">© {new Date().getFullYear()} {envConfigs.app_name}</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}